import * as firebase from "firebase/app"
import "firebase/messaging"

var firebaseConfig = {
  apiKey: "AIzaSyARqpV-OUD0L5pkg3hqWCHtaaNz3AL4m0U",
  authDomain: "ncms-71780.firebaseapp.com",
  databaseURL: "https://ncms-71780.firebaseio.com",
  projectId: "ncms-71780",
  storageBucket: "ncms-71780.appspot.com",
  messagingSenderId: "998370196157",
  appId: "1:998370196157:web:9c542e26e0792d7be6d5d4"
}

const initializedFirebaseApp = firebase.initializeApp(firebaseConfig)
const messaging = firebase.messaging.isSupported()
  ? initializedFirebaseApp.messaging()
  : null

messaging?.usePublicVapidKey(
  "BFXs-ELqM_TeZ47lgKGkvwbFgyEIwU10FKp_gywi_E-Nn4OULJKfT7eypBVIBhoO2GipgBCXS3UtZ1qdQM4AsPc"
)

export { messaging }
